/* CORDYGEN — Story scroll: crossfade the pinned image to match the chapter in view. */
(() => {
  'use strict';
  if (customElements.get('story-scroll')) return;
  customElements.define('story-scroll', class extends HTMLElement {
    connectedCallback() {
      this.chapters = Array.from(this.querySelectorAll('[data-chapter]'));
      this.frames = Array.from(this.querySelectorAll('[data-frame]'));
      this.dots = Array.from(this.querySelectorAll('[data-go]'));
      if (!this.chapters.length || !('IntersectionObserver' in window)) return;
      this.classList.add('is-ready');
      this.current = 0;
      this.io = new IntersectionObserver((entries) => {
        entries.forEach((en) => { if (en.isIntersecting) this.setActive(Number(en.target.dataset.chapter)); });
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
      this.chapters.forEach((c) => this.io.observe(c));
      this.dots.forEach((d) => d.addEventListener('click', () => {
        const c = this.chapters[Number(d.dataset.go)];
        if (c) c.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      }));
    }
    setActive(i) {
      if (i === this.current || Number.isNaN(i)) return;
      this.current = i;
      const toggle = (list, key) => list.forEach((el) => el.classList.toggle('is-active', Number(el.dataset[key]) === i));
      toggle(this.frames, 'frame');
      toggle(this.chapters, 'chapter');
      toggle(this.dots, 'go');
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); }
  });
})();
